<template>
    <div>
        <h1>{{title}}</h1>
        <div>
          <span>Call ID:</span>
          <input type="number" v-model="callId"/>
          <span>Attempt ID:</span>
          <input type="number" v-model="attemptId"/>
        </div>
        <div class="columns is-flex">
          <div class="column is-half">
          <h2>Volunteer</h2>
            <ul>
              <li v-for="(status, index) in volunteerStatusses" :key="index" class="my-1">
                <button @click="setStatus(status)" class="button is-info">{{ status }}</button>
              </li>
            </ul>
          </div>
          <div class="column is-half">
            <h2>Client</h2>
            <ul>
              <li v-for="(status, index) in clientStatusses" :key="index" class="my-1">
                <button @click="setStatus(status)" class="button is-info">{{ status }}</button>
              </li>
            </ul>
          </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { STATUS } from '../../../models/CallAttempt';
    import { startsWith, values } from 'lodash-es';

    export const Info = {
      name: 'Debug',
      path: 'Debug',
      hideInNav: true
    };

    export default {
      Info,
      props: {

      },
      data () {
        return {
          title: Info.name,
          callId: 1,
          attemptId: 1
        };
      },
      computed: {
        statusses () {
          return values(STATUS);
        },
        clientStatusses () {
          return this.statusses.filter(item => startsWith(item, 'client'));
        },
        volunteerStatusses () {
          return this.statusses.filter(item => startsWith(item, 'volunteer'));
        }
      },
      mounted () {
        console.log(STATUS, 'status');
      },
      methods: {
        setStatus (status) {
          axios.post(`/webhooks/regicall/calls/${this.callId}/callAttempts/events`, {
            call_attempt_id: this.attemptId,
            call_status: status,
            duration: 125
          })
            .then(function (response) {
              console.log(response);
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    };
</script>
